import {
  EClickableSize,
  TClickableVariants,
} from '@/components/atoms/at-clickable/at-clickable.types';

export const btnMock = {
  label: 'Find Your Home',
  size: EClickableSize.SM,
  variant: 'primary' as TClickableVariants,
  interactLocation: 'test',
};

export const linkMock = {
  href: '/',
  label: 'Home',
  interactLocation: 'test',
  ariaLabel: 'Home',
};
